import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useStateManager, useRoute, useRouteData } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';
import Classes, { CustomItemTypeCode, PositivePayCheckFile, PositivePayCheckTemplate } from "model";
import React, { useEffect } from 'react';
import "./styles.css";
import "./mobile.css";
import InfoAlertView from "components/shared/views/InfoAlertView";
import { SVGAsset } from "res";

/**
 * @function TASPositivePayImportChecksProcessingPage
 * @return {React.Component}
 * @exported true
 * @description The "TAS Positive Pay Import Checks Processing" page.
 */
export default function TASPositivePayImportChecksProcessingPage(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = { ...getDefaultData(undefined, context), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,


   });

  return (
    <PageContainer className="tas-positive-pay-import-checks-processing-page" state={ { data, ui } } controller={ controller }>
      <PageContent />
    </PageContainer>
  );
}

export const getDefaultData = () => {

  return {
      
  };
};

export const getDefaultUI = () => ({
  timeout: { useTimeout: true, value: 1000 }
});

function PageContent(props) {
    const { ui } = useStateManager();
    const navigate = useRoute();
    let { templateID = undefined, positivePayCheckFileID = undefined } = useRouteData().route ?? {};

    useEffect(() => {
        if(ui.timeout.useTimeout) {
            setTimeout(() => {
                navigate(
                  "/tasPositivePayImportChecksUsingTemplate",
                  { state: { templateID: templateID, positivePayCheckFileID: positivePayCheckFileID }}
                );
            }, ui.timeout.value);
        }
    }, []);

  return (
    <PageContentView>
         <CenterContentContainer>
            <ContentHeaderView text="Import Checks" />
            <InfoAlertView className="set-width" text={ `Please wait. The file import is processing.` }
            icon={ <SVGAsset id="InfoIcon" /> }/>
        </CenterContentContainer>
    </PageContentView>
  );
}